var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("SoliText", {
    ref: "email",
    attrs: {
      value: _vm.value,
      label: _vm.label,
      outlined: "",
      rules: _vm.emailRules,
      "hide-details": _vm.hideDetails,
      icon: "alternate_email",
      validateOnBlur: "",
      prevent: _vm.prevent,
      errors: _vm.errors,
    },
    on: {
      input: function ($event) {
        return _vm.$emit("input", $event)
      },
      "update:error": function ($event) {
        return _vm.validate($event)
      },
      "hook:mounted": function ($event) {
        return _vm.$emit("mounted")
      },
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }